/**
 * components/assistant/HseAiIcon.js — ХАБЭА ТУСЛАХЫН ДҮРС.
 *
 * Хэрэглэгчийн өгсөн HSE загвар (2026-11-05) дээр суурилсан: гурван өнгийн
 * нум цагираг + гурван тэмдэг — улаан зүрх (Health · эрүүл мэнд), ногоон
 * навч (Environment · байгаль орчин), шар дуулга (Safety · аюулгүй байдал),
 * голд нь «HSE»-ийн оронд «AI». Цагаан дэвсгэр дээр хамгийн тод — товч,
 * аватарт цагаан дугуйд хийнэ. Мобайлд ижил: hse_mobile/src/components/HseAiIcon.tsx.
 */
import React from "react";

export default function HseAiIcon({ size = 28, title }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : "true"}
      aria-label={title}
      focusable="false"
    >
      {/* Нум цагираг — тэмдгүүдийн ХООРОНД */}
      <path
        d="M40.54 13.82 A21 21 0 0 1 52.88 35.2"
        fill="none"
        stroke="#E11D2E"
        strokeWidth="6.5"
      />
      <path
        d="M44.34 49.99 A21 21 0 0 1 19.66 49.99"
        fill="none"
        stroke="#FACC15"
        strokeWidth="6.5"
      />
      <path
        d="M11.12 35.2 A21 21 0 0 1 23.46 13.82"
        fill="none"
        stroke="#16A34A"
        strokeWidth="6.5"
      />
      {/* Төв — «AI» */}
      <circle
        cx="32"
        cy="33"
        r="14"
        fill="#fff"
        stroke="#E2E8F0"
        strokeWidth="1"
      />
      <text
        x="32"
        y="38"
        textAnchor="middle"
        fontFamily="Arial, Helvetica, sans-serif"
        fontSize="13.5"
        fontWeight="800"
        fill="#1F2937"
      >
        AI
      </text>
      {/* Health — зүрх */}
      <circle
        cx="32"
        cy="12"
        r="8"
        fill="#fff"
        stroke="#E11D2E"
        strokeWidth="2.6"
      />
      <path
        transform="translate(32 12)"
        d="M0 3.6 C-4.6 0.4 -4.4 -3.6 -1.9 -3.6 C-0.9 -3.6 -0.3 -3 0 -2.3 C0.3 -3 0.9 -3.6 1.9 -3.6 C4.4 -3.6 4.6 0.4 0 3.6Z"
        fill="#E11D2E"
      />
      {/* Safety — дуулга */}
      <circle
        cx="50.19"
        cy="43.5"
        r="8"
        fill="#fff"
        stroke="#EAB308"
        strokeWidth="2.6"
      />
      <path
        transform="translate(50.19 43.5)"
        d="M-4.4 1.6 C-4.4 -2.6 -2.2 -4 0 -4 C2.2 -4 4.4 -2.6 4.4 1.6 Z M-5.4 1.6 H5.4 V2.9 H-5.4 Z"
        fill="#EAB308"
      />
      {/* Environment — навч */}
      <circle
        cx="13.81"
        cy="43.5"
        r="8"
        fill="#fff"
        stroke="#16A34A"
        strokeWidth="2.6"
      />
      <path
        transform="translate(13.81 43.5)"
        d="M-3.6 3.8 C-3.6 -1 -0.6 -3.8 3.8 -3.8 C3.8 0.8 1 3.8 -3.6 3.8 Z M-3.6 3.8 L1.6 -1.6"
        fill="#16A34A"
        stroke="#fff"
        strokeWidth="0.8"
      />
    </svg>
  );
}
